import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import { useWhitelabel } from 'main/framework'
import { Text as BaseText } from 'main/ui'
import { AssetName } from 'main/util/asset'
import { Container, PhoneLink, Title } from './NetworkContactDetails.styles'

const Text = BaseText.withComponent('div')

export function NetworkContactDetails() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const whitelabel = useWhitelabel()

  const title = whitelabel.getAsset(AssetName.NETWORK_CONTACT_DETAILS__SEARCH_PAGE__TITLE)
  const body = whitelabel.getAsset(AssetName.NETWORK_CONTACT_DETAILS__BODY)
  const phone = whitelabel.getAsset(AssetName.NETWORK_CONTACT_DETAILS__PHONE)
  const hasCopy = title && body && phone

  if (!hasCopy) {
    return null
  }

  return (
    <Container>
      <Title>{t(title)}</Title>
      <Text>
        {t(body)} <PhoneLink href={`tel:${t(phone)}`}>{t(phone)}</PhoneLink>.
      </Text>
    </Container>
  )
}
